// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f_Yk6","badges":"styles_badges__Jjus7"};